import "./RegStepPlan.scss";
import { LeftOutlined } from "@ant-design/icons";
import RegStepPlanOption from "./RegStepPlanOption";
import Tos from "./Tos";
import {Button} from "antd";
import { useRecoilState } from "recoil";
import { planLengthState, planTypeState } from "../../state/atoms";
import StepCounter from "../StepCounter";
import PlanLengthSwitch from "../PlanLengthSwitch";

interface RegStepPlanProps {
  onNext: () => void;
  onBack?: () => void;
  regStep: number;
  regStepTotal: number;
}

export default function RegStepPlan({ onNext, onBack, regStep, regStepTotal }: RegStepPlanProps) {
  const [planLength, setPlanLength] = useRecoilState(planLengthState);
  const [planType, setPlanType] = useRecoilState(planTypeState);

  return <div className={"step-type step full plan"}>
    {onBack && <div className={"back"} onClick={onBack}><LeftOutlined /></div>}
    <div className={"header"}>
      <StepCounter total={regStepTotal} current={regStep}/>
      <h2>Choose your plan and try it free.</h2>
    </div>

    <section>
      <PlanLengthSwitch planLength={planLength} setPlanLength={setPlanLength} />

      <div className="plan-container">
        <RegStepPlanOption planType={'design'} planLength={planLength} onClick={() => setPlanType('design')} active={planType === 'design'}/>
        <RegStepPlanOption planType={'pro'} planLength={planLength} onClick={() => setPlanType('pro')} active={planType === 'pro'}/>
      </div>

      <a href={"/menu/pricing.do"} className={'learn-more'} target={'_blank'} rel="noreferrer">Learn More</a>
    </section>

    <footer>
      <Tos />
      <div className={'divider'}/>
      <Button size={"large"} className={"primary"} disabled={!planType} onClick={onNext}>Get 7-Day Free Trial</Button>
    </footer>
  </div>;
}
